import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LeadListComponent } from './list/lead-list.component';
import { LeadDetailsComponent } from './details/lead-details.component';
import { LeadManagmentComponent } from './lead-managment.component';

const routes: Routes = [
  {
    path: '', component: LeadManagmentComponent,
    children: [
      { path: '', redirectTo: 'list', pathMatch:'full'},
      { path: 'list', component: LeadListComponent },
      { path: 'details/:leadId', component: LeadDetailsComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LeadManagmentRoutingModule { }
